export default __webpack_public_path__ + "static/media/rank-act.462f0fd9.svg";